import { TAvatarSize } from '../../avatar.types';
import { TAvatarMark } from './avatar-marks.types';

export const AVATAR_MARK_SIZE_MAP: Readonly<Record<TAvatarSize, number>> = {
  Xlarge: 24,
  large: 18,
  medium: 14,
  small: 14,
  Xsmall: 10,
} as const;

export const AVATAR_MARK_ASSETS_MAP: Readonly<
  Record<TAvatarMark, (p: React.SVGProps<SVGSVGElement>) => JSX.Element>
> = {
  wrong: require('@assets/svg/avatar-mark/wrong.svg').ReactComponent,
  'doctor-read': require('@assets/svg/avatar-mark/doctor-read.svg').ReactComponent,
  lock: require('@assets/svg/avatar-mark/lock.svg').ReactComponent,
  read: require('@assets/svg/avatar-mark/read.svg').ReactComponent,
  angel: require('@assets/svg/avatar-mark/angel.svg').ReactComponent,
  success: require('@assets/svg/avatar-mark/success.svg').ReactComponent,
  'patient-avatar': require('@assets/svg/avatar-mark/patient-avatar.svg').ReactComponent,
  'expert-avatar': require('@assets/svg/avatar-mark/expert-avatar.svg').ReactComponent,
  'is-expert': require('@assets/svg/avatar-mark/is-expert.svg').ReactComponent,
  unread: require('@assets/svg/avatar-mark/unread.svg').ReactComponent,
  'no-smoker': require('@assets/svg/avatar-mark/no-smoker.svg').ReactComponent,
  smoker: require('@assets/svg/avatar-mark/smoker.svg').ReactComponent,
} as const;
